// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-content {
  background-color: #fff;
  width: 100%;
  height: 500px;
}

#v-pills-tab .active {
  background-color: #fff;
  color: #000;
}

#tabPrincipal {
  background-color: #c4c4c4;
}

.report-style {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  height: 800px;
  aspect-ratio: 1/1;
  width: 100%;
}


.fullscreen {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: white; /* Asegúrate de que el fondo sea blanco o el color que prefieras */
  z-index: 9999;
}


.fullscreen .card {
  width: 100%;
  height: 100%;
  margin: 0;
  border: none;
  border-radius: 0;
}

.fullscreen .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fullscreen .card-body {
  height: calc(100% - 56px); /* Adjust based on your header height */
  overflow: auto;
}

.fullscreen .btn {
  font-size: 1.5rem;
}

.powerbi-embed-fullscreen {
  /* Agrega aquí los estilos adicionales que deseas aplicar al PowerBIEmbed en modo de pantalla completa */
  /* Por ejemplo, ajustar el tamaño, posición, etc. */
  width: 100%;
  height: 100%;
  /* Otros estilos */
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/reportes.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,iBAAiB,EAAE,kEAAkE;EACrF,aAAa;AACf;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,uCAAuC;EAClE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wGAAwG;EACxG,mDAAmD;EACnD,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".tab-content {\n  background-color: #fff;\n  width: 100%;\n  height: 500px;\n}\n\n#v-pills-tab .active {\n  background-color: #fff;\n  color: #000;\n}\n\n#tabPrincipal {\n  background-color: #c4c4c4;\n}\n\n.report-style {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 10px;\n  margin-right: 10px;\n  padding: 10px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  height: 800px;\n  aspect-ratio: 1/1;\n  width: 100%;\n}\n\n\n.fullscreen {\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: white; /* Asegúrate de que el fondo sea blanco o el color que prefieras */\n  z-index: 9999;\n}\n\n\n.fullscreen .card {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  border: none;\n  border-radius: 0;\n}\n\n.fullscreen .card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.fullscreen .card-body {\n  height: calc(100% - 56px); /* Adjust based on your header height */\n  overflow: auto;\n}\n\n.fullscreen .btn {\n  font-size: 1.5rem;\n}\n\n.powerbi-embed-fullscreen {\n  /* Agrega aquí los estilos adicionales que deseas aplicar al PowerBIEmbed en modo de pantalla completa */\n  /* Por ejemplo, ajustar el tamaño, posición, etc. */\n  width: 100%;\n  height: 100%;\n  /* Otros estilos */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
